import { Directive, ElementRef, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';

@Directive({
  selector: '[resize]'
})
export class ResizeDirective implements OnInit, OnDestroy {

  @Output()
  public resize = new EventEmitter<any>();
  private observer: any;

  constructor(private ref: ElementRef) {
  }

  ngOnInit() {
    this.observer = new ResizeObserver(() => this.resize.emit());
    this.observer.observe(this.ref.nativeElement);
  }

  ngOnDestroy() {
    this.observer.disconnect();
  }
}
